import { render, staticRenderFns } from "./PrkObjectiveEffectsModal.vue?vue&type=template&id=794f8440&scoped=true&"
import script from "./PrkObjectiveEffectsModal.vue?vue&type=script&lang=js&"
export * from "./PrkObjectiveEffectsModal.vue?vue&type=script&lang=js&"
import style0 from "./PrkObjectiveEffectsModal.vue?vue&type=style&index=0&id=794f8440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f8440",
  null
  
)

export default component.exports